import React, { useState } from 'react';

import {
    AddCommentsInput,
    AddCommentsOutput,
    Comment
} from '@amzn/coral_com-amazon-musicpapercontractconfigurationservice';
import { UnknownCoralError } from '@amzn/ihm-js-coral-client';
import Button from '@amzn/meridian/button';
import Card from '@amzn/meridian/card';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Textarea from '@amzn/meridian/textarea';

import { contractConfigurationClient } from 'src/api/client';
import { AppContext } from 'src/contexts/appContext';

import { LoaderForBtn } from '../../ConfirmationModal';

interface ICommentInputProps {
    category: string;
    categoryUniqueColumnId: number;
    onCommentAdded?: (comment: Comment) => void;
    buttonText?: string;
    placeholder?: string;
    disableCommentInput?: boolean;
}

export const CommentInput = ({
    category,
    categoryUniqueColumnId,
    onCommentAdded,
    buttonText = 'Add Comment',
    placeholder = 'Add a comment...',
    disableCommentInput = true
}: ICommentInputProps) => {
    const [commentText, setCommentText] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const { setTopAlertMsg, userInfo } = React.useContext(AppContext);

    const addCommentHandler = () => {
        if (!commentText.trim()) return;

        setIsLoading(true);
        contractConfigurationClient
            .addComments(
                AddCommentsInput.clone({
                    category: category,
                    categoryUniqueColumnIds: [categoryUniqueColumnId],
                    comment: commentText.trim(),
                    user: userInfo.username
                })
            )
            .subscribe(
                (response: AddCommentsOutput) => {
                    if (response.comments) {
                        setCommentText('');
                        if (onCommentAdded) {
                            onCommentAdded(response.comments[0]);
                        }
                        setIsLoading(false);
                    }
                },
                (error: UnknownCoralError) => {
                    console.error('addComments Unexpected error', error.receivedException.message);
                    setTopAlertMsg(error.receivedException.message);
                    setIsLoading(false);
                }
            );
    };

    return (
        <Card spacingInset="400">
            <Column>
                <Textarea
                    value={commentText}
                    onChange={setCommentText}
                    placeholder={placeholder}
                    disabled={isLoading || disableCommentInput}
                />
                <Row widths="fit" alignmentHorizontal="end">
                    <Button
                        onClick={addCommentHandler}
                        disabled={commentText.trim().length === 0 || isLoading || disableCommentInput}
                        size="small"
                    >
                        {isLoading ? LoaderForBtn : buttonText}
                    </Button>
                </Row>
            </Column>
        </Card>
    );
};
